module.exports = __webpack_public_path__ + "img/home-off.f0c0bac6.png";